import { Navigate } from "react-router-dom";
import {
  ALL_REGIONS_CODE,
  getStoredRegion,
} from "@/features/regions/constants";

// Landing redirect for region-less paths ("/"): pick up the last-opened region
// from localStorage (default "all") and send the user into /<region>/users.
// If the stored value is stale/invalid, RegionLayout self-corrects it.
export default function RegionEntryRedirect() {
  const region = getStoredRegion() || ALL_REGIONS_CODE;
  return <Navigate to={`/${region}/users`} replace />;
}
